<template>
    <div class="container-fluid">
        <div class="block-header">
            <bread-crumb :displayViewAllCampaigns="true"></bread-crumb>
        </div>
        <div class="row clearfix">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="body crowdfunding-main d-flex justify-content-between flex-column flex-md-row">
                        <div class="left-crowdfunding border rounded">
                            <ul class="list-unstyled mb-0 text-center">
                                <li><img src="@/assets/images/crowdfunding.svg" class="mw-100" alt=""></li>
                                <li>
                                    <h4 class="mt-3 mb-1">Welcome to Angel Communities</h4>
                                </li>
                                <li>
                                    <p>What are you CrowdFunding for?</p>
                                </li>
                            </ul>
                        </div>
                        <div class="right-crowdfunding d-flex flex-column justify-content-between">
                            <div class="right-top border rounded cursor-pointer" @click="redirectCampaignType('cause')">
                                <ul class="list-unstyled mb-0 text-center">
                                    <li>
                                        <h4>A Cause</h4>
                                    </li>
                                    <li>
                                        <p class="mb-0">0% platform fee <i class="fa fa-question-circle"
                                                aria-hidden="true"></i></p>
                                    </li>
                                </ul>
                            </div>
                            <div class="right-bot border rounded cursor-pointer" @click="redirectCampaignType('project')">
                                <ul class="list-unstyled mb-0 text-center">
                                    <li>
                                        <h4>A Project</h4>
                                    </li>
                                    <li>
                                        <p class="mb-0">1% platform fee <i class="fa fa-question-circle"
                                                aria-hidden="true"></i></p>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LandingComponent',
    components: {
        BreadCrumb: () => import('@/components/BreadCrumb.vue'),
    }, methods: {
        redirectCampaignType(selectedType) {
            this.$router.push({ name: 'campaign-type', params: { type: selectedType } });
        }
    }
}
</script>
